import { render, staticRenderFns } from "./MyConfig.vue?vue&type=template&id=46c5e821&"
import script from "./MyConfig.vue?vue&type=script&lang=js&"
export * from "./MyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports